import {axios} from '@/utils/request'

// 查询已办任务列表
export function finishedList(query) {
  return axios({
    url: '/jeecg-oa/flowable/task/finishedList',
    method: 'get',
    params: query
  })
}

// 查询已办任务列表
export function finishedListNew(query) {
  return axios({
    url: '/jeecg-oa/flowable/task/finishedListNew',
    method: 'get',
    params: query
  })
}

// 任务流转记录
export function flowRecord(query) {
  return axios({
    url: '/jeecg-oa/flowable/task/flowRecord',
    method: 'get',
    params: query
  })
}

// 任务流转记录
export function flowRecordBydataid(query) {
  return axios({
    url: '/jeecg-oa/flowable/task/flowRecordBydataid',
    method: 'get',
    params: query
  })
}

// 撤回任务
export function revokeProcess(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/revokeProcess',
    method: 'post',
    data: data
  })
}

// 收回任务
export function recallProcess(data) {
  return axios({
    url: '/jeecg-oa/flowable/task/recallProcess',
    method: 'post',
    data: data
  })
}

// 部署流程实例
export function deployStart(deployId) {
  return axios({
    url: '/jeecg-oa/flowable/process/startFlow/' + deployId,
    method: 'get',
  })
}

// 查询流程定义详细
export function getDeployment(id) {
  return axios({
    url: '/system/deployment/' + id,
    method: 'get'
  })
}

// 新增流程定义
export function addDeployment(data) {
  return axios({
    url: '/system/deployment',
    method: 'post',
    data: data
  })
}

// 修改流程定义
export function updateDeployment(data) {
  return axios({
    url: '/system/deployment',
    method: 'put',
    data: data
  })
}

// 删除流程实例
export function delDeployment(id,dataid) {
  return axios({
      url: '/jeecg-oa/flowable/instance/delete/?instanceId=' + id + '&dataId=' + dataid,
      method: 'delete'
  })
}

// 导出流程定义
export function exportDeployment(query) {
  return axios({
    url: '/system/deployment/export',
    method: 'get',
    params: query
  })
}
